import { statusValue } from "constants/general";

export enum ImportTypes {
  GROUP_VALUE = "groupValue",
  MEMBER = "member",
  SEGMENT_MEMBERS = "segmentMembers",
  TRANSACTION = "transaction",
  UNIT_TRANSFER_ADDING = "unitTransferAdding",
  UNIT_TRANSFER_SPENDING = "unitTransferSpending",
  REWARD_COUPON = "rewardCoupon",
}

export type ImportTypesUnion = `${ImportTypes}`;

export type ImportListItem = {
  importId: string;
  type: ImportTypesUnion;
  uploadedDate: string;
  fileName: string;
  itemsToImport: number;
  user: string;
  errorMessage?: string;
  additionalData?: {
    rewardId: string;
    rewardName: string;
  };
};

export type ImportStatus = (typeof statusValue)[keyof typeof statusValue];

export type SucceedImportDetails = {
  importId: string;
  status: ImportStatus;
  createdAt: string;
  createdOn: string;
  updatedAt: string;
  message: string;
};

export type EntityDetails<T> = {
  id: string;
  data: T;
};
